import * as React from 'react';
const SvgAccessibility = (props) => (
  <svg viewBox="0 0 159 102" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M79.5 4.954C124.737 4.954 156.124 51 156.124 51S124.734 97.046 79.5 97.046C34.266 97.046 2.872 51 2.872 51S34.262 4.954 79.497 4.954h.003Z"
      stroke="#000"
      strokeWidth={3.65}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.422 83.824c18.172 0 32.904-14.696 32.904-32.824S98.595 18.176 80.422 18.176c-18.173 0-32.905 14.696-32.905 32.824S62.25 83.824 80.422 83.824Z"
      stroke="#000"
      strokeWidth={3.65}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66.53 49.512 77.815 60.77l18.449-18.404M9.835 14.304V7.26a4.402 4.402 0 0 1 4.406-4.396h7.06M21.301 99.132h-7.06a4.402 4.402 0 0 1-4.406-4.396v-7.043M149.162 87.693v7.043a4.402 4.402 0 0 1-4.406 4.395h-7.061M137.699 2.865h7.06a4.401 4.401 0 0 1 4.406 4.396v7.043"
      stroke="#000"
      strokeWidth={3.65}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgAccessibility;
